import { isObject, mergeWith } from 'lodash-es';

function customizer(oldValue: Array<unknown> | object, newValue: Array<unknown> | object): object | (unknown[] & object) {
  if (Array.isArray(newValue)) {
    return newValue;
  }

  if (Array.isArray(oldValue) && typeof newValue === 'undefined') {
    return oldValue;
  }

  if (isObject(newValue) && !Object.keys(newValue).length) {
    // reset nested objects if no keys provided
    return newValue;
  }

  return isObject(newValue) ? mergeWith(oldValue, newValue, customizer) : newValue;
}

export default function (oldObj: object, newObj: object): object | (unknown[] & object) {
  return mergeWith(oldObj, newObj, customizer);
}
